import { useEffect, useState } from 'react';
import CompanyDetails from './CompanyDetails';
import AccountUserInfo from './AccountUserInfo';
import RegisteredAddress from './RegisteredAddress';
import BusinessAddress from './BusinessAddress';
import WarehouseAddress from './WarehouseAddress';
import StoreAddress from './StoreAddress';
import DocumentUploads from './DocumentUploads';
import OtherDetails from './OtherDetails';
import { getPincodeData, checkGstUNique, checkEmailUnique,send_otp_email,send_otp_mobile, CheckPhoneUnique } from './utils';
import OtpPopup from './OtoPopup';
import Loader from '../../components/Loader';
import { IoMdArrowRoundBack } from 'react-icons/io';
import { useNavigate } from 'react-router-dom';

const CompanyRegistrationForm = () => {
  const nvg = useNavigate();
  const [showOtpPopup, setShowOtpPopup] = useState(false);
  const [loader, setloader] = useState(false);   
  





  const handleGetOtp = async () => {
    await send_otp_email(formData.accountUserEmail)
    await send_otp_mobile(formData.accountUserMobile)
    setShowOtpPopup(true);
  };

  const required_field_static = [
    "companyName", "companyType", "gstin", "natureOfBusiness", "dateOfEstablishment", "panNo", "accountUserName", "accountUserDesignation", "accountUserMobile",
    "accountUserEmail", "registeredAddress", "registeredPincode", "businessAddress", "businessPincode","agreeToTerms"
  ]
  const static_error_template = {
    companyName: '',
    companyType: '',
    natureOfBusiness: '',
    dateOfEstablishment: '',
    gstin: '',
    isUnregisteredDealer: "",
    panNo: '',
    accountUserName: '',
    accountUserDesignation: '',
    accountUserMobile: '',
    accountUserEmail: '',


    registeredAddress: '',
    registeredPincode: '',
    registeredCity: '',
    registeredState: '',
    registeredCountry: '',

    businessAddress: '',
    sameAsRegistered: "",
    businessPincode: '',
    businessCity: '',
    businessState: '',
    businessCountry: '',

    warehouseAddress: '',
    warehousePincode: '',
    warehouseCity: '',
    warehouseState: '',
    warehouseCountry: '',

    storeAddress: '',
    storePincode: '',
    storeCity: '',
    storeState: '',
    storeCountry: '',


    websiteUrl: '',
    panCard: "",
    aadharCard: "",
    gstinCertificate: "",
    incorporationCertificate: "",
    authorizationLetter: "",
    msmeCertificate: "",


    agreeToTerms: ''
  }

  const [requiredField, SetRequiredFiled] = useState(required_field_static);

  const [uploadState, setUploadState] = useState([])
  const [formData, setFormData] = useState({
    companyName: '',
    companyType: '',
    natureOfBusiness: '',
    dateOfEstablishment: '',
    gstin: '',
    isUnregisteredDealer: false,
    panNo: '',
    accountUserName: '',
    accountUserDesignation: '',
    accountUserMobile: '',
    accountUserEmail: '',


    registeredAddress: '',
    registeredPincode: '',
    registeredCity: '',
    registeredState: '',
    registeredCountry: '',

    businessAddress: '',
    sameAsRegistered: "",
    businessPincode: '',
    businessCity: '',
    businessState: '',
    businessCountry: '',

    warehouseAddress: '',
    warehousePincode: '',
    warehouseCity: '',
    warehouseState: '',
    warehouseCountry: '',

    storeAddress: '',
    storePincode: '',
    storeCity: '',
    storeState: '',
    storeCountry: '',


    websiteUrl: '',
    panCard: "",
    aadharCard: "",
    gstinCertificate: "",
    incorporationCertificate: "",
    authorizationLetter: "",
    msmeCertificate: "",


    agreeToTerms: false

  });
  const [errorData, setErrorData] = useState({
    ...static_error_template
  });

  
  
  const handlePicCode = async (pincode, name) => {

    const prefix = name.split("P")[0]
    const addressDetails = await getPincodeData(pincode)

    const changeData = {
      [`${prefix}City`]: addressDetails.city,
      [`${prefix}State`]: addressDetails.state,
      [`${prefix}Country`]: addressDetails.country,
      [`${prefix}Pincode`]: pincode

    }

    setFormData({ ...formData, ...changeData })


  }

   const AddRequiredField = (isUnregistered,fieldname,value) =>{
    
    if(value)
    {
      SetRequiredFiled(prevList => {
    const newList = [...prevList];
     
    return newList.filter(state => state !== fieldname );
  })
    }
    else{
       SetRequiredFiled(prevList => {

     return [...prevList,fieldname] } );
  
    }
  }

  const handleChange = (e) => {
    let { name, value, type, checked } = e.target

    if (name === 'accountUserMobile') {
      value = value.replace(/\D/g, '').slice(0, 10);
    }
    if (errorData[name].length > 0) {
      setErrorData({ ...errorData, [name]: "" })
    }
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
      "gstin": name == "gstin" ? value : name === "isUnregisteredDealer" ? "" : prev.gstin,
      "isUnregisteredDealer": name == "companyType" ? false : name === "isUnregisteredDealer" ? checked : prev.isUnregisteredDealer,
    }));

    const isUnregistered = name === "isUnregisteredDealer" ? checked : formData.isUnregisteredDealer;
    
  

    if (name === 'sameAsRegistered' && checked) {
      setFormData(prev => ({
        ...prev,
        businessAddress: prev.registeredAddress,
        businessPincode: prev.registeredPincode,
        businessCity: prev.registeredCity,
        businessState: prev.registeredState,
        businessCountry: prev.registeredCountry
      }));
    }

    if(name === "isUnregisteredDealer"){
      AddRequiredField(isUnregistered,"gstin",checked);
      AddRequiredField(isUnregistered,"gstinCertificate",checked);
    }
    if (name === "companyType") handleUpload(value)
    if (name.includes("Pincode") && value.length >= 6) handlePicCode(value, name)

  };

   const handleBlur = async (e) => {


    const { name, value } = e.target;

    let response;

    switch (name) {
      case 'gstin':
        response = await checkGstUNique(value);
        if (response.data == "Gst Already Exists.") {
          setErrorData({ ...errorData, [name]: response.data })
        }
        break

      case "accountUserMobile":

      response = await CheckPhoneUnique(value)
      
      if (!response) 
        {
          setErrorData({ ...errorData, [name]: "User Already Exist" })
        }
   
      
      
        
        break;
        // case 'panNumber':
      //   await checkPanUnique(value);
      //   break;
      // case 'aadharNumber':
      //   await checkAadharUnique(value);
      //   break;
      case 'accountUserEmail':
        response = await checkEmailUnique(value)
        if (response.data === "Email Already Exists.") setErrorData({ ...errorData, [name]: response.data })

        break

      default:
        console.log(`No validation function for field: ${name}`);
    }







  }
 
  const handleUpload = (selectionData) => {
    let arrayOfUpload
    let arrayOfUploadRequired
    switch (selectionData) {
      case "LLP":
        arrayOfUpload = [ "panCard", "gstinCertificate", "incorporationCertificate", "authorizationLetter", "msmeCertificate"]
        arrayOfUploadRequired = [ "panCard", "gstinCertificate", "incorporationCertificate", "authorizationLetter", "msmeCertificate"]
        break;
      case "Private Limited":
        arrayOfUpload = [ "panCard", "gstinCertificate", "incorporationCertificate", "authorizationLetter", "msmeCertificate"]
        arrayOfUploadRequired = [ "panCard", "gstinCertificate", "incorporationCertificate", "authorizationLetter", "msmeCertificate"]
        break;
      case "Public Limited":
        arrayOfUpload = ["panCard", "gstinCertificate", "incorporationCertificate", "authorizationLetter", "msmeCertificate"]
        arrayOfUploadRequired = ["panCard", "gstinCertificate", "incorporationCertificate", "authorizationLetter", "msmeCertificate"]
        break;
      case "Partnership":
        arrayOfUpload = [ "panCard", "aadharCard", "gstinCertificate", "authorizationLetter", "msmeCertificate"]
        arrayOfUploadRequired = [ "panCard", "aadharCard","gstinCertificate", "authorizationLetter", "msmeCertificate"]
        break;
      case "Sole Proprietorship":
        arrayOfUpload = [ "panCard", "aadharCard", "gstinCertificate", "msmeCertificate"]
        arrayOfUploadRequired = [ "panCard","gstinCertificate", "aadharCard", "msmeCertificate"]
        break;
      default:
       arrayOfUpload = ["panCard", "gstinCertificate", "incorporationCertificate", "authorizationLetter", "msmeCertificate"]
       arrayOfUploadRequired = ["panCard", "gstinCertificate", "incorporationCertificate", "authorizationLetter", "msmeCertificate"]
        break;
    }
    setUploadState(arrayOfUpload);
    SetRequiredFiled([...required_field_static, ...arrayOfUploadRequired]);
  }

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: files[0]
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

      // handleGetOtp()
const files_list = ["panCard", "gstinCertificate", "incorporationCertificate", "authorizationLetter", "msmeCertificate"]
const address_list = [ 
    "warehouseAddress",
    "warehousePincode",
    "warehouseCity",
    "warehouseState",
    "warehouseCountry",
    "storeAddress",
    "storePincode",
    "storeCity",
    "storeState",
    "storeCountry",
  ]

const dynamicState = [
  "gstin"
]

    const formDataToSend = new FormData();

    var tempErrorData = { }

  if (formData.panNo && formData.panNo.length !== 10) {
    tempErrorData.panNo = "PAN number must be 10 characters long";
  }
  if (formData.accountUserMobile && formData.accountUserMobile.length !== 10) {
    tempErrorData.accountUserMobile = "Mobile number must be 10 characters long";
  }

  
  if (!formData.isUnregisteredDealer && formData.gstin && formData.gstin.length !== 15) {
    tempErrorData.gstin = "GSTIN must be 15 characters long";
  }

    
    for (const key in formData) {
      


      if(files_list.includes(key) && requiredField.includes(key) && formData[key]?.length === 0 )
      {

        tempErrorData[key] = "This Field is Required"
      }
      
      else if ( formData[key] instanceof File && formData[key].size == 0 && requiredField.includes(key)) {
      
        
        tempErrorData[key] = "This Field is Required"
      }
      else if (dynamicState.includes(key))
      {

        
        if(requiredField.includes(key) && formData[key].length === 0)
        {
          tempErrorData[key] = "This Field is Required"
        }

      }


      else if (!(files_list.includes(key) || key === "sameAsRegistered" || address_list.includes(key) || key === "isUnregisteredDealer" || key === "websiteUrl" ) && ((formData[key] === null || formData[key]?.length === 0 || formData[key] == false) && requiredField.includes(key)) ) {   
           
        
        
            
        tempErrorData[key] = "This Field is Required"
           
      }else{
        formDataToSend.append(key, formData[key]);
      }

    }




    
    if (Object.keys(tempErrorData).length > 0 ) {
      let errorsObject = { ...static_error_template, ...tempErrorData };
      setErrorData(errorsObject)
      for (const key in errorsObject) {
        if (errorsObject[key] && errorsObject[key].trim() !== "") {
          return setfocusinput(key); 
        }
      }
      return
    }
    setErrorData({ ...static_error_template })
        handleGetOtp()

  }

  const [focusinput,setfocusinput] = useState('')
  useEffect(() => {
    const inputElement = document.getElementById(focusinput);
    if (inputElement) {
      inputElement.focus();
    }
  }, [focusinput]);

 

  return (
    <section
      className="section-big-pt-space pb-2"
      style={{ backgroundColor: "rgb(249 249 249)" }}
    >
      <div className="col-lg-12 col-sm-12 col-xs-12 mt-lg-3 mt-xs-4">
        <div className="container-fuild emp-profile">
          <div
            className="row profileregister"
            style={{
              boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
            }}
          >

            <div style={{ display: 'flex', justifyContent: 'flex-end',paddingRight: '36px',paddingTop:'15px',cursor:'pointer' }}onClick={() => nvg('/')}>
                <IoMdArrowRoundBack size={24} color="#0CB744" />
              </div>

            <div className="card p-1" style={{ border: "none", marginTop: '40px' }}>
              <img
                src={`${process.env.REACT_APP_API_PUBLIC_URL}/images/newlogo/newlogooneup.png`}
                className="login-tabs-img customwidth"
                style={{ marginBottom: "0px", cursor: "pointer" }}
                alt=""
              />
            </div>
            {loader ? <div className='d-flex justify-content-center py-4' > <Loader /> </div> : <form  >

              <div className="container">
                <CompanyDetails formData={formData} handleBlur={handleBlur} handleChange={handleChange} errorData={errorData} requiredField={requiredField} />
                <AccountUserInfo formData={formData} handleBlur={handleBlur} handleChange={handleChange} errorData={errorData} />

                <div className="d-flex gap-3">
                  <div className="w-50">
                    <RegisteredAddress formData={formData} handleBlur={handleBlur} errorData={errorData} handleChange={handleChange} />
                  </div>
                  <div className="w-50">
                    <BusinessAddress formData={formData} handleBlur={handleBlur} errorData={errorData} handleChange={handleChange} />
                  </div>
                </div>

                <div className="d-flex gap-3">
                  <div className="w-50">
                    <WarehouseAddress formData={formData} handleBlur={handleBlur} errorData={errorData} handleChange={handleChange} />
                  </div>

                  <div className="w-50">
                    <StoreAddress formData={formData} handleBlur={handleBlur}  errorData={errorData} handleChange={handleChange} />
                  </div>
                </div>

                <DocumentUploads
                  formData={formData}
                  handleChange={handleChange}
                  handleFileChange={handleFileChange}
                  errorData={errorData}
                  uploadState={uploadState}
                />
                <OtherDetails formData={formData} handleChange={handleChange} errorData={errorData} />

                <div className="text-center mb-4">
                  <button
                    onClick={handleSubmit}
                    type="button"
                    className="btn btn-lg text-white w-100 w-md-auto"
                    style={{ backgroundColor: '#0CB744', width: '170px', maxWidth: '200px' }}
                  >
                    GET OTP
                  </button>
                </div>


                <div>
             

                 
                  {showOtpPopup && (
                
                        <OtpPopup
                          onClose={() => setShowOtpPopup(false)}
                          formdata={formData}
                          loader={setloader}
                         
                      
                        />
               
                  )}
                </div>

           


              </div>
            </form>}
            
          </div>
        </div>
      </div>
    </section>


  );
};

export default CompanyRegistrationForm;